// extracted by mini-css-extract-plugin
export default {"container":"Main_container__uzGJG","button":"Main_button__IOCf9","slidein":"Main_slidein__0daZ5"};